import React from "react";
import { ReactComponent as CallIcon } from "../../../assets/icons/call.svg";
import axios from "axios";
import { useEffect, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import { ReactComponent as Outgoing } from "../../../assets/icons/outgoingcall.svg";

const AvailableBalance = (props) => {

  const statusColor = {
    "Sufficient": "bg-green-500",
    "Too Low": "bg-orange-500",
    "Low Credit": "bg-yellow-300",
    "No Credit": "bg-red-500",
  };

  const badgeClass = statusColor[props.creditData?.credit_status] || "bg-red-500";

  // alert(props.creditData?.credit_status)
  console.log("AvailableBalance ------   :  ")

  return (
    <div className="font-karla">
      <div className="p-6 ">
        <div className="flex justify-between items-center pt-4 space-x-4">
          <div className="bg-light-white rounded-md w-full h-16 pt-2 ">
            <h1 className="text-center font-bold text-lg text-gray-700">{props.creditData?.credit.remaining_credit? props.creditData.credit.remaining_credit : 0}</h1>
            <p className="text-center text-sm text-gray-700">Balance Credit</p>
          </div>
          <div className="bg-light-white rounded-md w-full h-16 pt-2 ">
            <div className="flex justify-center">
              <h1 className={`text-center text-lg text-gray-700 ${props.creditData?.credit?.plan === "unlimited"? 'pe-2' : ''}`}>
                {props.creditData?.credit?.plan ?? "limited"}
              </h1>

              {props.creditData?.credit?.plan === "unlimited" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-6 h-6 text-green-600 mt-[0.18rem]"
                >

                  <path d="M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z" />
                </svg>
              ) : null}

              
            </div>

            <p className="text-center text-sm text-gray-700">Existing Plan</p>
          </div>
        </div>
      </div>
      <h1 className="font-bold text-[20px] p-7 pb-0">Available Balance</h1>

      <div className="overflow-auto no-scrollbar p-5 h-[500px] overflow-y-auto">

        <div className="flex justify-between bg-light-white rounded-md w-full h-16 mt-2 items-center">

          <p className="pl-4 font-bold text-md text-gray-700">
            Credit Status
          </p>

          <div
            className={`flex items-center justify-center 
            px-6 h-full 
            rounded-tl-3xl rounded-br-lg 
            ${badgeClass}
            shadow-md`}
          >
            <span
              className={`font-bold text-md ${
                props.creditData?.credit_status === "Low Credit"
                  ? "text-black"
                  : "text-white"
              }`}
            >
              {props.creditData?.credit_status || "Sufficient"}
            </span>
          </div>

        </div>


      </div>
    </div>
  );
};

export default AvailableBalance;
